<template>
  <div class="bg" :style="{ fontFamily: fonts,background: 'url(' + bgUrl + ') no-repeat center / 100% 100%' }">
    <home-header @changeFont="changeF"></home-header>
    <div class="bgbody">
      <div class="center">
        <div class="header">请选择签到方式，谢谢！</div>
        <div class="registerCon">
          <div class="registerLeft">
            <div class="leftLine">会议时间：{{ timeArea }}</div>
            <div class="leftLine">会议主题：{{ theme }}</div>
            <div class="leftLine">已签到人数：{{ participants.length }}人</div>
            <div class="leftLine">
              未签到人数：{{ unregisterlist.length }}人
            </div>
            <div class="leftLine three">{{ timeTip }}</div>
          </div>
          <div class="registerRight">
            <div class="imgBox" @click="registerCode">
              <img src="../assets/rec1.png" alt="" />
              <div class="imgtext">二维码签到</div>
            </div>
            <div class="imgBox" @click="registerFace">
              <img src="../assets/rec2.png" alt="" />
              <div class="imgtext">人脸签到</div>
            </div>
          </div>
        </div>
        <!-- <div class="registerBottomContainer"> -->
        <div class="registerBottom">
          <div class="leftButton">已签到</div>
          <div class="bottomList">
            <ul :style="{ width: participants.length * 233 + 'px' }">
              <li v-for="(i, index) in participants" :key="index">
                <div class="AstarLi">
                  <div class="astarText">{{ i.attendeeName }}</div>
                  <div class="astarText">{{ i.signTime }}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- <div class="registerBottom">
            <div class="leftButton leftButton1">未签到</div>
            <div class="bottomList">
              <ul :style="{ width: unregisterlist.length * 162 + 'px' }">
                <li v-for="(i, index) in unregisterlist" :key="index">
                  <div class="AstarLi">
                    <div class="astarText">{{ i.attendeeName }}</div>
                    <div class="astarText">{{ i.attendeeTel }}</div>
                  </div>
                </li>
              </ul>
            </div>
          </div> -->
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { personLists, getMeetModel } from "@/utils/request";
import HomeHeader from "./header";
import moment from "moment";
export default {
  name: "register",
  components: {
    HomeHeader
  },
  data() {
    return {
      fonts: "",
      timeArea: "",
      meetingName: "",
      theme: "",
      meetingStarttime: "",
      meetingEndtime: "",
      clock: null,
      timeClock: null,
      timeTip: "",
      id: "",
      faceCode: "",
      QRCode: 1,
      participants: [],
      unregisterlist: [],
      isAuto: "yes",
      bgUrl:''
    };
  },
  mounted() {
    // console.log(this.$route.query.meetingId)
    this.bgUrl = localStorage.getItem('bgUrl')
    this.id = this.$route.query.id;
    this.equipmentName = this.$route.query.equipmentName;
    this.meetingId = this.$route.query.meetingId;
    this.meetingName = this.$route.query.meetingName;
    this.theme = this.$route.query.theme;
    this.meetingStarttime = this.$route.query.startTime;
    this.meetingEndtime = this.$route.query.endTime;
    this.timeArea =
      moment(new Date(this.meetingStarttime)).format("HH:mm") +
      "-" +
      moment(new Date(this.meetingEndtime)).format("HH:mm");
    // this.timeClock = setInterval(() => {
    //   this.getMeetModels();
    // }, 3000);
    this.personLists();
    this.isAuto = localStorage.getItem("isAuto");
  },
  created() {
    this.initDaojishi();
  },
  destroyed() {
    if (this.clock) {
      clearInterval(this.clock);
    }
    // if (this.timeClock) {
    //   clearInterval(this.timeClock);
    // }
  },
  methods: {
    // getMeetModels() {
    //   getMeetModel().then(res => {
    //     if (Number(res.code) === 0) {
    //       this.fonts = res.data.fontStyle;
    //     }
    //   });
    // },
    initDaojishi() {
      if (this.clock) {
        clearInterval(this.clock);
      } else {
        this.clock = window.setInterval(() => {
          const curdate = new Date().getTime();
          const meetingStartTimeseconds = new Date(
            this.meetingStarttime
          ).getTime();
          const meetingEndTimeseconds = new Date(this.meetingEndtime).getTime();
          let msec = Math.abs(meetingStartTimeseconds - curdate);
          let hr =
            parseInt(msec / 1000 / 60 / 60) >= 10
              ? parseInt(msec / 1000 / 60 / 60)
              : "0" + parseInt(msec / 1000 / 60 / 60);
          let min =
            parseInt((msec / 1000 / 60) % 60) >= 10
              ? parseInt((msec / 1000 / 60) % 60)
              : "0" + parseInt((msec / 1000 / 60) % 60);
          let sec =
            parseInt((msec / 1000) % 60) >= 10
              ? parseInt((msec / 1000) % 60)
              : "0" + parseInt((msec / 1000) % 60);
          if (meetingStartTimeseconds > curdate) {
            //会议开始时间大于当前时间，会议已经开始了
            this.timeTip = "距离开始时间：" + hr + ":" + min + ":" + sec;
            // console.log(this.timeTip);
          } else {
            this.timeTip = "会议开始计时中：" + hr + ":" + min + ":" + sec;
            if (meetingEndTimeseconds < curdate) {
              //会议结束了
              this.$router.push({
                path: "/",
                query: {
                  equipmentName: this.equipmentName,
                  meetingId: this.meetingId,
                  meetingName: this.meetingName
                }
              });
            }
            if (this.isAuto === "yes") {
              this.$router.push({
                path: "/advertising",
                query: {
                  equipmentName: this.equipmentName,
                  meetingId: this.meetingId,
                  meetingName: this.meetingName,
                  id: this.id,
                  theme: this.theme,
                  startTime: this.meetingStarttime,
                  endTime: this.meetingEndtime
                }
              });
            }
          }
        }, 1000);
      }
    },
    registerFace() {
      this.$router.push({
        path: "/registerFace",
        query: {
          equipmentName: this.equipmentName,
          meetingId: this.meetingId,
          id: this.id,
          meetingName: this.name
        }
      });
    },
    registerCode() {
      this.$router.push({
        path: "/qrCode",
        query: {
          equipmentName: this.equipmentName,
          meetingId: this.meetingId,
          id: this.id,
          meetingName: this.meetingName
        }
      });
    },
    personLists() {
      let params = {
        id: this.id
      };
      personLists(params).then(res => {
        if (res.code == 0) {
          this.participants = res.data.signList;
          this.unregisterlist = res.data.unSignList;
        }
      });
    },
    changeF(font) {
      this.fonts = font;
    }
  }
};
</script>

<style lang="less" scoped>
.bg {
  width: 100%;
  height: 100%;
  color: #fff;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  // padding: 6% 1s0%;
  font-size: 36px;
  .bgbody {
    // padding: 5% 0;
    position: fixed;
    top: 15%;
    left: 0;
    right: 0;
    bottom: 0;
    .center {
      width: 70%;
      height: 80%;
      margin: 0 auto;
      background: rgba(255, 255, 255, 0.1);
      padding: 3% 8%;
      // font-weight: bold;
      .header {
        text-align: center;
        font-size: 40px;
        margin-bottom: 5%;
        letter-spacing: 3px;
      }
      .registerCon {
        display: flex;
        margin-bottom: 5%;
        .registerLeft {
          line-height: 2;
          width: 55%;
          padding-left: 5%;
          letter-spacing: 3px;
          margin-right: 5%;
          .three {
            color: #fff000;
          }
        }
        .registerRight {
          width: 40%;
          display: flex;
          .imgBox {
            width: 40%;
            text-align: center;
            img {
              width: 100%;
            }
            .imgtext {
              font-size: 20px;
              margin-top: 2%;
            }
          }
          .imgBox:nth-of-type(1) {
            margin-right: 49px;
          }
        }
      }
      // .registerBottomContainer {
      // display: flex;
      // height: 200px;
      .registerBottom {
        // width: 100%;
        flex: 1;
        // overflow: hidden;
        display: flex;

        .leftButton {
          width: 3%;
          height: 15%;
          text-align: center;
          background: radial-gradient(
            rgba(0, 0, 0, 0) 0,
            rgba(255, 255, 255, 0.4) 100%
          );
          margin-right: 29px;
          border-radius: 5px;
          font-size: 30px;
          padding: 25px 5px;
          color: #2ad8fe;
        }
        .leftButton1 {
          color: #ffb668;
        }
        .bottomList {
          width: 100%;
          overflow: hidden;
          overflow-x: auto;
          ul {
            height: 100%;
            li {
              float: left;
              font-size: 20px;
              margin-right: 32px;
              width: 200px;
              height: 100%;
              // img{
              //   width: 108px;
              //   height: 108px;
              //   margin-bottom: 28px;
              //   margin-top: 6px;
              // }
              .AstarLi {
                height: 100%;
                .astarText {
                  text-align: center;
                  height: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }
              }
            }
          }
          .bottomList::-webkit-scrollbar {
            display: none;
          }
        }
      }
      // }
    }
  }
}
@media screen and (max-width: 1440px) {
  .bg .center .registerCon {
    font-size: 20px;
    margin-bottom: 80px;
  }
  .bg .center .registerCon .registerRight .imgBox .imgtext {
    font-size: 16px;
  }
  // .bg .bgbody{
  //   padding: 10% 0;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/register.vue